module.exports = __webpack_public_path__ + "static/media/BBQH2705a.cf7260f8.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/explore/rapeles_salto/BBQH2705a.JPG
// module id = 93
// module chunks = 0